import { render, staticRenderFns } from "./UpsertUser.vue?vue&type=template&id=64d1f42a&scoped=true"
import script from "./UpsertUser.vue?vue&type=script&lang=js"
export * from "./UpsertUser.vue?vue&type=script&lang=js"
import style0 from "./UpsertUser.vue?vue&type=style&index=0&id=64d1f42a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d1f42a",
  null
  
)

export default component.exports